// Validation utilities for our glossary terms

import { Action, ActionType } from './Action';
import { ActionSubject, ActionSubjectType } from './ActionSubject';
import { ActionSubjectId, ActionSubjectIdType } from './ActionSubjectId';
import { Source, SourceType } from './Source';
import {
  ScreenEvent,
  UIEvent,
  TrackEvent,
  OperationalEvent,
} from '@atlassiansox/analytics-web-client';

const isValidAction = (a: ActionType) => {
  const validAction = Object.values(Action);
  return validAction.includes(a);
};
const isValidActionSubject = (a: ActionSubjectType) => {
  const validActionSubject = Object.values(ActionSubject);
  return validActionSubject.includes(a);
};
const isValidActionSubjectId = (a: ActionSubjectIdType) => {
  const validActionSubjectId = Object.values(ActionSubjectId);
  return validActionSubjectId.includes(a);
};
const isValidSource = (s: SourceType) => {
  const validSources = Object.values(Source);
  return validSources.includes(s);
};

interface InvalidTerms {
  action?: string;
  actionSubject?: string;
  actionSubjectId?: string;
  source?: string;
}

export const checkForInvalidTerms = (
  e: UIEvent | TrackEvent | OperationalEvent,
  eventType: string,
) => {
  // Log console error only if in a dev environment, but always return
  // invalidTerms for the subsequent sendValidationFailureEvent call

  const hasActionSubjectIdValidation = eventType !== 'track';
  const invalidTerms: InvalidTerms = {};

  if (!isValidAction(e.action)) {
    if (__DEV__) {
      console.error(
        `'${e.action}' is not a valid Action (see packages/atlassian-analytics/src/constants/Action.ts)`,
      );
    }
    invalidTerms.action = e.action;
  }
  if (!isValidActionSubject(e.actionSubject)) {
    if (__DEV__) {
      console.error(
        `'${e.actionSubject}' is not a valid ActionSubject (see packages/atlassian-analytics/src/constants/ActionSubject.ts)`,
      );
    }
    invalidTerms.actionSubject = e.actionSubject;
  }
  if (
    // Ignore actionSubjectId type vs string for UI/operational events vs track
    hasActionSubjectIdValidation &&
    e.actionSubjectId &&
    // @ts-ignore: Argument of type 'string' is not assignable
    !isValidActionSubjectId(e.actionSubjectId)
  ) {
    if (__DEV__) {
      console.error(
        `'${e.actionSubjectId}' is not a valid ActionSubjectId (see packages/atlassian-analytics/src/constants/ActionSubjectId.ts)`,
      );
    }
    invalidTerms.actionSubjectId = e.actionSubjectId;
  }
  if (!isValidSource(e.source)) {
    if (__DEV__) {
      console.error(
        `'${e.source}' is not a valid Source (see packages/atlassian-analytics/src/constants/Source.ts)`,
      );
    }
    invalidTerms.source = e.source;
  }
  if (Object.keys(invalidTerms).length > 0) {
    return invalidTerms;
  }
};

export const checkForInvalidScreenTerms = (e: ScreenEvent) => {
  // Log console error only if in a dev environment, but always return
  // invalidTerms for the subsequent sendValidationFailureEvent call

  if (!isValidSource(e.name)) {
    if (__DEV__) {
      console.error(
        `'${e.name}' is not a valid Source (see packages/atlassian-analytics/src/constants/Source.ts)`,
      );
    }
    return { name: e.name };
  }
};
